import React from 'react';
import { useNavigate } from 'react-router-dom';
import SectionPliable from '../../../composants/SectionPliable/SectionPliable';
import TableauComplements from '../../../composants/TableauComplements/TableauComplements';
import { CommandeBC, LienComplementBC } from '../types';
import { estOuvrable, lignesComplements } from '../domain/complements';

interface CommandesComplementairesProps {
  commande: CommandeBC;
}

// Section « Commandes complementaires » de l'onglet Notification et signature, cote PRESTATAIRE.
// Meme tableau que l'acheteur (la commande initiale puis ses complements), sans bouton : c'est
// l'acheteur qui cree. Une ligne mene a la commande du titulaire dans ce bon, et seulement si
// l'acheteur la lui a envoyee ; avant, elle reste visible mais fermee.
const CommandesComplementaires: React.FC<CommandesComplementairesProps> = ({ commande }) => {
  const navigate = useNavigate();
  const idOperation = commande.operation?.id;
  if (!idOperation) return null;

  return (
    <SectionPliable title="Commandes complémentaires" defaultOpen>
      <div className="section-content">
        <TableauComplements<LienComplementBC>
          lignes={lignesComplements(commande)}
          idCourant={idOperation}
          estOuvrable={estOuvrable}
          onOuvrir={(ligne) => ligne.commande_titulaire && navigate(`/commande-bc/${ligne.commande_titulaire.id}`)}
          mentionNonOuvrable="En préparation par l'acheteur"
        />
      </div>
    </SectionPliable>
  );
};

export default CommandesComplementaires;
